import React, { Fragment } from 'react';
import './Footer.scss'
import { AiFillInstagram, AiFillLinkedin } from 'react-icons/ai';
import { GrMail } from 'react-icons/gr';
import { OpenExternalLink } from '../../Utilities';
import { instagramLink, linkedinLink, mailLink } from '../../Constants';



export default function Footer() {
    return (
        <Fragment>
            <div className="footer-container">
                <div className='mentions'>
                    <span className='mentions-link' onClick={() => { OpenExternalLink("http://www.nazmkf.com/", false) }}>Designed by Nazm Furniturewala</span>
                </div>
                <div className="social-media">
                    <span className='social-icon'>
                        <AiFillLinkedin color='var(--secondary-color)' size={30} onClick={() => { OpenExternalLink(linkedinLink, false) }} />
                    </span>
                    <span className='social-icon'>
                        <AiFillInstagram color='var(--secondary-color)' size={30} onClick={() => { OpenExternalLink(instagramLink, false) }} />
                    </span>
                    <span className='social-icon'>
                        <GrMail color='var(--secondary-color)' size={30} onClick={() => { OpenExternalLink(mailLink, true) }} />
                    </span>
                </div>
                <div className='mentions'>
                    <span className='mentions-link' onClick={() => { OpenExternalLink("http://www.premieronetech.com/", false) }}>Developed by PremierOne Tech</span>
                </div>
            </div>
        </Fragment>
    );
};